var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share-outside-Sekeron---Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sharing-any-post-outside-sekeron-171",
    transform: "translate(-716, -652)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(676, 380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(0, 30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(0, 74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(0, 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-(2)",
    transform: "translate(40, 92.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16 C32,23.98625 26.14875,30.605625 18.5,31.805625 L18.5,20.625 L22.228125,20.625 L22.9375,16 L18.5,16 L18.5,12.99875 C18.5,11.733125 19.12,10.5 21.1075,10.5 L23.125,10.5 L23.125,6.5625 C23.125,6.5625 21.29375,6.25 19.543125,6.25 C15.88875,6.25 13.5,8.465 13.5,12.475 L13.5,16 L9.4375,16 L9.4375,20.625 L13.5,20.625 L13.5,31.805625 C5.85125,30.605625 0,23.98625 0,16 C0,7.16375 7.16375,0 16,0 C24.83625,0 32,7.16375 32,16 Z",
    id: "Path",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.228125,20.625 L22.9375,16 L18.5,16 L18.5,12.9986875 C18.5,11.733375 19.119875,10.5 21.1074375,10.5 L23.125,10.5 L23.125,6.5625 C23.125,6.5625 21.294,6.25 19.5434375,6.25 C15.8886875,6.25 13.5,8.465 13.5,12.475 L13.5,16 L9.4375,16 L9.4375,20.625 L13.5,20.625 L13.5,31.8055625 C14.314625,31.933375 15.1495,32 16,32 C16.8505,32 17.685375,31.933375 18.5,31.8055625 L18.5,20.625 L22.228125,20.625 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.95cbea33fc7197e05c67c8b9b30f1fce.svg";
export { ForwardRef as ReactComponent };